import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const NexusSyncContext = createContext({
  publishMutation: () => {},
  lastMutation: null,
});

export const NexusSyncProvider = ({ children }) => {
  const [mutations, setMutations] = useState([]);

  const publishMutation = useCallback((mutation) => {
    if (!mutation || !mutation.metadata) {
      return;
    }
    setMutations((prev) => {
      const next = [...prev, { ...mutation, timestamp: Date.now() }];
      return next.slice(-25);
    });
  }, []);

  const value = useMemo(
    () => ({
      publishMutation,
      lastMutation: mutations[mutations.length - 1] || null,
    }),
    [mutations, publishMutation]
  );

  return <NexusSyncContext.Provider value={value}>{children}</NexusSyncContext.Provider>;
};

export const useNexusSync = () => useContext(NexusSyncContext);
